/**
 * Formatta il nome di una strategia rimuovendo il prefisso e acronimizzando le prime tre parole.
 *
 * @param {string} strategyName - Il nome completo della strategia (es. "NNStrategy-gap_and_go_long_gib1_15m")
 * @returns {string} Il nome formattato (es. "GAG LONG GIB1 15M")
 *
 * @example
 * formatStrategyName("NNStrategy-gap_and_go_long_gib1_15m")
 * // returns "GAG LONG GIB1 15M"
 *
 * @example
 * formatStrategyName("NNSTRATEGY-GAP_AND_GO_LONG_GIB1_15M")
 * // returns "GAG LONG GIB1 15M"
 */
export function formatStrategyName(strategyName) {
    if (!strategyName || typeof strategyName !== 'string') {
        return strategyName;
    }

    // Rimuove il prefisso "NNStrategy-" o "NNSTRATEGY-" (case insensitive)
    let formattedName = strategyName.replace(/^NNStrategy-/i, '');

    // Sostituisce gli underscore con spazi
    formattedName = formattedName.replace(/_/g, ' ');

    // Split delle parole
    const words = formattedName.split(' ').filter(word => word.length > 0);

    // Se ci sono meno di 3 parole, restituisce il nome senza il prefisso in maiuscolo
    if (words.length < 3) {
        return formattedName.toUpperCase();
    }

    // Prende le prime tre parole e crea l'acronimo
    const firstThreeWords = words.slice(0, 3);
    const acronym = firstThreeWords.map(word => word.charAt(0).toUpperCase()).join('');

    // Prende il resto delle parole e le converte in maiuscolo
    const remainingWords = words.slice(3);

    // Combina l'acronimo con le parole rimanenti (tutto maiuscolo)
    return remainingWords.length > 0
        ? `${acronym} ${remainingWords.map(w => w.toUpperCase()).join(' ')}`
        : acronym;
}
